import { createApiClient } from "./client";

const client = createApiClient();

export const exams = {
  saveDemographics: ({ data, userId }) =>
    client
      .post(
        `/participants/${userId}/demographics`, data
      )
      .then(({ data }) => data),

  getAssesmentsv2: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/candidates/${id}/exams?per_page=${perPage}&page=${currentPage}${
          type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),

  getSurveys: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/participants/${id}/surveys?per_page=${perPage}&page=${currentPage}${
          type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),

  getReviews: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/reviewers/${id}/surveys?per_page=${perPage}&page=${currentPage}${
          type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),
  // getExamQuestionsv2: ({ userId, examId, userExamId,language ,showOnlyQuestions, switchQuestion, level, number_of_attempts }) =>
  //   client
  //     .get(`/candidates/${userId}/exams/${examId}/questions/${userExamId}?showOnlyQuestions=${showOnlyQuestions}&language=${language}${
  //       switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
  //     }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}`)
  //     .then(({ data }) => data),

   getExamQuestionsv2: ({ userId, examId, userExamId,language ,showOnlyQuestions, switchQuestion, level, number_of_attempts }) =>
    client
      .get(`/participants/${userId}/surveys/${examId}?showOnlyQuestions=${showOnlyQuestions}&language=${language}${
        switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
      }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}`)
      .then(({ data }) => data),

    getReviewerExamQuestionsv2: ({ userId, userExamId, reviewerId}) =>
    client
      .get(`reviewers/${reviewerId}/participants/${userId}/surveys/${userExamId}`)
      .then(({ data }) => data),

    getSurveyResponse: ({ userId, userExamId}) =>
    client
      .get(`/view-responses/${userId}/${userExamId}`)
      .then(({ data }) => data),

  /* UPDATE ANSWERS */
  updateAnswersv2: ({ data, userId, examId, userExamId }) =>
    client
      .post(
        `/participants/${userId}/surveys/${userExamId}/save-answers`,
        //`/candidates/${userId}/exams/${examId}/questions/${userExamId}/save-answers`,
        data
      )
      .then(({ data }) => data),

  updateAnswersv2Review: ({ data, userId, examId, userExamId, reviewerId }) =>
    client
      .post(
        `/reviewers/${reviewerId}/participants/${userId}/surveys/${userExamId}/save-answers`,
        data
      )
      .then(({ data }) => data),

  // gradeAssessmentv2: ({ userId, examId, userExamId, attempt  }) =>
  //   client
  //     .post(
  //       `/candidates/${userId}/exams/${examId}/questions/${userExamId}/submit-exam`, {attempt}
  //     )
  //     .then(({ data }) => data),

  gradeAssessmentv2: ({ userId, examId, userExamId, attempt  }) =>
    client
      .post(
        `/participants/${userId}/surveys/${examId}/submit-assessment`, {attempt}
      )
      .then(({ data }) => data),

  gradeSurveyReviewv2: ({ userId, examId, userExamId, attempt, reviewerId  }) =>
    client
      .post(
        `/reviewers/${reviewerId}/participants/${userId}/surveys/${examId}/submit-assessment`,
      )
      .then(({ data }) => data),
  getExamsHistoryv2: ({ id, currentPage, perPage, search }) =>
    client
      .get(
        `/candidates/${id}/exams/history?per_page=${perPage}&page=${currentPage}${
          search ? `&search=${search}` : ""
        }`
      )
      .then(({ data }) => data),

  getBookingsv2: (userId, examId) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/bookings`)
      .then(({ data }) => data),

  getBranding: () =>
    client
      .get(`/clients/6b9d247d-78ba-417f-9fcf-ae8fc3e574d9`)
      .then(({ data }) => data),

  createBookingv2: ({ userId, examId, payload }) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings`, { ...payload })
      .then(({ data }) => data),

  unlockAssessmentv2: (userId, examId, payload) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings/activate`, {
        ...payload,
      })
      .then(({ data }) => data),

  loginBasedLinkExam: (payload) =>
    client.post(`/auth/login/exam`, { ...payload }).then(({ data }) => data),
  getExamResults: ({userId, examId, userExamId}) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/results/${userExamId}`)
      .then(({ data }) => data),
  retakeExam: ({userId, examId}) =>
        client
          .post(`/candidates/${userId}/exams/${examId}/retry`)
          .then(({ data }) => data),
};
